"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getVideoOutputName;

function capitalise(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getVideoOutputName(output, videoName) {
  return output.name || "".concat(videoName, " (").concat(output.isMaster ? 'Master' : capitalise(output.aspectRatio.toLowerCase()), ")");
}